/**
 * Device docs the caller may read, for the dashboard's capacity counts.
 *
 * The `devices` read rule is tenancy-scoped (`canReadInfra` in
 * firestore.rules): shared platform hardware (`ownerOrgId == null`) is visible
 * to everyone, a private edge only to its org. Rules are not filters, so a
 * tenant's query must itself say which owners it wants — one query for the
 * shared commons, one for the org's own edges. A super admin may read the
 * whole collection in one query.
 */
import {
  collection,
  getDocs,
  query,
  where,
  type Firestore,
  type QueryConstraint,
  type QueryDocumentSnapshot,
} from 'firebase/firestore';

export async function getVisibleDeviceDocs(
  db: Firestore,
  organizationId: string | null | undefined,
  isSuperAdmin: boolean,
  constraints: QueryConstraint[] = []
): Promise<QueryDocumentSnapshot[]> {
  const devices = collection(db, 'devices');
  if (isSuperAdmin) {
    return (await getDocs(query(devices, ...constraints))).docs;
  }
  const owners: (string | null)[] = organizationId ? [null, organizationId] : [null];
  const snaps = await Promise.all(
    owners.map((owner) => getDocs(query(devices, where('ownerOrgId', '==', owner), ...constraints)))
  );
  return snaps.flatMap((snap) => snap.docs);
}
